// utils/whatsappLogHelper/log.ts - utils/whatsappLogHelper.ts split (sub-module log)

import { supabase } from '../../supabase/client';

import type {WhatsAppLogData} from './types.js';


/**
 * Create WhatsApp log entry
 */
export async function logWhatsAppMessage(data: WhatsAppLogData): Promise<{ success: boolean; error?: string }> {
    try {
        // RPC SECURITY DEFINER (whitelist kolom) — insert langsung dari client
        // di-block RLS (whatsapp_logs cuma punya policy SELECT). Pola sama
        // dengan update_public_order / log_client_error.
        // SEMUA param WAJIB terkirim (undefined dihilangkan dari body JSON →
        // PostgREST tak menemukan signature fungsi → 404). Kosong = null.
        const { error } = await supabase.rpc('insert_whatsapp_log', {
            p_order_id: data.orderId ?? null,
            p_abandoned_cart_id: data.abandonedCartId ?? null,
            p_phone_number: data.phoneNumber ?? null,
            p_message_type: data.messageType ?? null,
            p_message_preview: data.messagePreview ?? null,
            p_message_content: data.messageContent ?? null,
            p_status: data.status ?? null,
            p_error_message: data.errorMessage ?? null,
            p_fonnte_response: data.fonntResponse ?? null,
            p_whatsapp_number_id: data.whatsappNumberId ?? null,
            p_whatsapp_device_name: data.whatsappDeviceName ?? null,
            p_customer_name: data.customerName ?? null,
            p_notes: data.notes ?? null,
        });

        if (error) {
            console.error('[WhatsApp Log] Insert error:', error);
            return { success: false, error: error.message };
        }

        console.log('[✅ WhatsApp Log] Entry created for order:', data.orderId);
        return { success: true };
    } catch (err) {
        console.error('[❌ WhatsApp Log] Exception:', err);
        return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
    }
}
